define('modules/lp_integration/views/email_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/email_popup','./validation_popup'],function(require, exports, module){
  "use strict";
  var ModalView = require("common/views/modal_view");
  module.exports = ModalView.extend({
    template: require("ldsh!../templates/email_popup"),
    events: {
      "click .js-save": "save",
      "click .js-cancel": "hide"
    },
    initialize: function(options){

    },
    helpers: function(){
      return {
        recipients: this.model.get("recipients").join(", ")
      };
    },
    i18n: {
      validation: {
        subject: "integration.emailSubjectError",
        recipients: "integration.emailRecipientsError"
      }
    },
    save: function(e){
      var recipients = this.$('#recipients').val(),
          subject = this.$('#subject').val().trim();
      this.model.saveRecipients(recipients);
      this.model.set("subject", subject);
      if (this.model.isValid()){
        //this.clearErrorMessages();
        this.model.set("active", !this.model.isEmpty());
        this.model.save(null,{patch:true});
        this.hide();
        return;
      }
      //this.showErrorMessages();
      this.model.set("active", false);
      e.preventDefault();
    }
  });

  _.extend(module.exports.prototype, require("./validation_popup"));

});


